import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as contentful from 'contentful';
import Fade from 'react-reveal/Fade';
import {
  BrowserView,
  MobileView
} from "react-device-detect";


import videoMP4 from '../assets/bg-d.mp4';
import videoWEBm from '../assets/bg-d.webm';
import bg from '../assets/bg.gif';



class Work extends Component {

  state = {
    posts: [],
    refeBg : "",
    loading: true
  }

  client = contentful.createClient({
    space: 'fygct0me4xfd',
    accessToken: '72c82731a8873e4620dace6005f32eb0aa6ec31e576007fefe92e57fa2e73fc7'
  })

  componentDidMount() {
    setTimeout(() => this.setState({ loading: false }), 500); 
    this.fetchPosts().then(this.setPosts);
    
    document.body.classList.remove('hide');
  }

  fetchPosts = () => this.client.getEntries({
    'content_type': 'work',
    order: 'sys.createdAt'
  })

  setPosts = response => {
    this.setState({
      posts: response.items
    })
  }

  
    
  render() {


    document.body.classList.add('hide');

    const { loading } = this.state;

    if(loading) { 
      return null; 
    }


    return (
 

      <div className="px-8 md:px-16 xl:px-64 py-12 md:py-32 z-40 relative text-white">
       

      <div className="w-full relative z-40">
        <Fade>
          <h1 className="text-5xl md:text-huge-md xl:text-huge mt-16">Works</h1>
        </Fade>
        <Fade delay={300}>
          <div>
          {this.state.posts.map(({fields}, i) =>
            <Link key={i} className="ml-12 md:ml-32 big-link relative font-light text-xl md:text-3xl text-white block no-underline my-2 md:my-4" to={fields.slug}><span>{fields.title}</span></Link>
          )}
          </div>
          </Fade>
      </div>

      <BrowserView>
        <div className="video-container">
          <video autoPlay loop muted>
            <source src={videoMP4} type="video/mp4" />
            <source src={videoWEBm} type="video/webm" />
          </video>
        </div>
      </BrowserView>
      <MobileView>
        <div className="video-container bg-cover bg-center" style={{backgroundImage: "url(" + bg + ")"}}>
        </div>
      </MobileView>

      </div>
    );
  }
}

export default Work;


// WEBPACK FOOTER //
// ./src/pages/Work.js